// extracted by mini-css-extract-plugin
export default {"expired-page":"style_expired-page__l1-Zy","wrapper":"style_wrapper__e9Dzx","footer":"style_footer__+GUd9","copyright":"style_copyright__Z1YWd"};